import {
  GET_PATIENT_DIET,
  CREATE_PATIENT_DIET,
  UPDATE_PATIENT_DIET,
  DELETE_PATIENT_DIET,
  axios,
  baseURL,
} from "./types";

// 1. GET ALL (Normal: Jo data pass karoge wahi jayega)
export const getPatientDiet = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/appointmentPatientDiet/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data, // HospitalID aapko component se pass karni hogi
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GET_PATIENT_DIET,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

// 2. CREATE
export const createPatientDiet = (formData) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/appointmentPatientDiet/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: formData,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATE_PATIENT_DIET,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

// 3. UPDATE
export const updatePatientDiet = (formData) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/appointmentPatientDiet/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: formData,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATE_PATIENT_DIET,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

// 4. DELETE
export const deletePatientDiet = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/appointmentPatientDiet/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETE_PATIENT_DIET,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};